export default __webpack_public_path__ + "static/media/look-inside-room.96812a33.jpg";